import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/common/services/user.service';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { take } from 'rxjs/operators';
import { UserManager } from 'src/app/core/services/user-manager';

@Component({
  selector: 'app-annulla-documento-protocollo',
  templateUrl: './annulla-documento-protocollo.component.html',
  styleUrls: ['./annulla-documento-protocollo.component.css']
})
export class AnnullaDocumentoProtocolloComponent implements OnInit {
  form: FormGroup;
  currentOperator: string; // Nome e Cognome dell'operatore

  constructor(
    private fb: FormBuilder,
    private dialogRef: DialogRef,
    private userService: UserService,
    private userManager: UserManager
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      estremiProvvedimento: ['', Validators.required],
      dataAnnullamento: [new Date(), Validators.required],
      identificativoOperatore: [{ value: '', disabled: true }]
    });
    let utenteLoggato= this.userManager.getUser();
    console.log('utenteLoggato',utenteLoggato) 
      if (utenteLoggato) {
        this.currentOperator = `${utenteLoggato.nome} ${utenteLoggato.cognome}`;
        this.form.get('identificativoOperatore')?.setValue(this.currentOperator);
      }
 
  }

  conferma() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      estremiProvvedimento: this.form.get('estremiProvvedimento')?.value,
      dataAnnullamento: this.form.get('dataAnnullamento')?.value,
      identificativoOperatore: this.currentOperator
    };

    this.dialogRef.close({ modalEvent: true, data: payload });
  }

  annulla() {
    this.dialogRef.close({ modalEvent: false });
  }
}
